// DWallet tokens supported by the CMS — single source of truth for
// CoinGecko ids and display formatting (decimalsFormat = số lẻ khi hiển thị,
// not the token's on-chain decimals): stablecoins 2, others 4.
export const TOKENS = {
  BTC: { name: "Bitcoin", coingeckoId: "bitcoin", decimalsFormat: 4 },
  ETH: { name: "Ethereum", coingeckoId: "ethereum", decimalsFormat: 4 },
  XRP: { name: "XRP", coingeckoId: "ripple", decimalsFormat: 4 },
  SOL: { name: "Solana", coingeckoId: "solana", decimalsFormat: 4 },
  USDT: { name: "Tether", coingeckoId: "tether", decimalsFormat: 2 },
  USDC: { name: "USD Coin", coingeckoId: "usd-coin", decimalsFormat: 2 },
};

export const TOKEN_DEFAULT_DECIMALS_FORMAT = 4;

export const getToken = (symbol) => TOKENS[String(symbol).toUpperCase()];
